import { redirect } from "react-router";

const checkAuth = () => {
  const user = localStorage.getItem("userId");

  if (!user) {
    return redirect("/sign-in");
  }

  return null;
};
export default checkAuth;
